
const network = require( './network/network_api' );

export default function(
    $state,
    leaf,
)
{
    let isIn = false;
    
    //freespin:
    $state
        .filter( state => state.type == network.TYPE.FREEGAME )
        .subscribe( state =>
        {
            if ( ! isIn )
            {
                isIn = true;
                console.log( "RX: start freegames" );
                leaf.space.s( "start" ).next( state.state.stage.math );
            }
            
            console.log( "RX:start freespin" );
            leaf.space.s( "freespin" ).next( state );
        } );
    
    //non freespin:
    $state
        .filter( state => state.type != network.TYPE.FREEGAME )
        .subscribe( state => isIn = false );
}




// WEBPACK FOOTER //
// ./src/library/freegames.es6